module.exports = __webpack_public_path__ + "static/PPNeueMontreal-Regular-9a46b7989a8ea306f3d583d7270dff0c.woff2";